;
/*!
 * subitotexto.comments.js
 */
SubitoTexto.comments = {
	init                        : function () {
		var $ = jqPla,
			_this = SubitoTexto.comments;

		_this.$mainContainer = $('.comments-form-and-comments');
		_this.$container = $( '#form_comment' );
		_this.$commentsList = $( '#comment_list' );


		_this.$commentNameField = _this.$container.find( '[name="txt_name"]' );
		_this.$commentCommentField = _this.$container.find( '[name="txt_comment"]' );

		_this.$messageSuccess = _this.$mainContainer.find( '.message-success' );

		_this.replaceEmojisClientSide();

		_this.bindEvents();
	}, // init()
	bindEvents                  : function () {
		var $ = jqPla,
			_this = SubitoTexto.comments;

		_this.$container.on( 'click', '#btn_submit_comment', _this.submit );
		_this.$commentsList.on( 'click', 'a#show_all', _this.showAllComments );


		_this.prepFieldsForEmojiConversion();

	}, // bindEvents()
	replaceEmojisClientSide     : function ($selector) {
		var $ = jqPla,
			_this = SubitoTexto.comments;

		_this.$comments = _this.$commentsList.find( 'article' );


		if ( _this.$comments.length > 0 ) {

			_this.$comments.find( 'h3, div' ).each( function ( i, el ) {
				var $this = $( this ),
					htmlOriginal = $this.html(),
					convertedHtml = SubitoTexto.emoji.convertFromDb( htmlOriginal );

				// No use in doing this if there are no emoji
				if ( htmlOriginal != convertedHtml ) {
					$this.html( convertedHtml );
				}
			} );
		}
	},
	showAllComments             : function ( e ) {
		var $ = jqPla,
			_this = SubitoTexto.comments;

		e.preventDefault();

		$( this ).remove();

		_this.$commentsList.find( '#comment_all' ).show();
		$( 'html, body' ).animate( { scrollTop: $( '#comment_all' ).offset().top }, 600 );
	}, // bindEvents()
	prepFieldsForEmojiConversion: function () {
		var $ = jqPla,
			_this = SubitoTexto.comments;

		_this.$commentNameField.on( 'keyup', function ( e ) {
			if ( typeof _this.$commentNameFieldEmojiPartner == 'undefined' ) {
				_this.$commentNameFieldEmojiPartner = _this.$container.find( '#' + _this.$commentNameField.data( 'emoji-partner' ) );
			}

			if ( _this.$commentNameFieldEmojiPartner.length > 0 ) {
				_this.$commentNameFieldEmojiPartner.val( SubitoTexto.emoji.prepForDb( _this.$commentNameField.val() ) );
			}
		} );


		_this.$commentCommentField.on( 'keyup', function ( e ) {
			if ( typeof _this.$commentCommentFieldEmojiPartner == 'undefined' ) {
				_this.$commentCommentFieldEmojiPartner = _this.$container.find( '#' + _this.$commentCommentField.data( 'emoji-partner' ) );
			}

			if ( _this.$commentCommentFieldEmojiPartner.length > 0 ) {
				_this.$commentCommentFieldEmojiPartner.val( SubitoTexto.emoji.prepForDb( _this.$commentCommentField.val() ) );
			}
		} );


		_this.$commentNameField.trigger( 'keyup' );
		_this.$commentCommentField.trigger( 'keyup' );
	},

	submit: function ( e ) {
		var $ = jqPla,
			_this = SubitoTexto.comments,
			$form = $( '#form_comment' );

		e.preventDefault();

		if ( $form.is( '.working' ) ) {
			return false;
		}
		$form.addClass( 'working' );
		$.ajax( {
			data    : $form.serialize(),
			dataType: 'json',
			type    : 'post',
			url     : CONFIG.comments_url
		} ).done( function ( _data ) {

			$form.removeClass( 'working' );

			SubitoTexto.form.processForm( $form, _data.errors, false );

			if ( _data.success == 1 ) {
				_this.$messageSuccess.find('p').show();

				$( '#form_comment' ).hide();
				if ( $(window).width() < 1200 ) {
					PLA.UTILS.scrollTop.scrollTo( _this.$messageSuccess, -40 );
				}
			}

		} );
	} // submit()
}; // SubitoTexto.comments